import zhCNMenu from '../zh-CN/menu';

export default {
  ...zhCNMenu,
  'menu.attraction.setting': 'Attraction Settings',
  'menu.attraction.claimConversion': 'Claim and Conversion Rules',
  'menu.navigation.contractSettings': 'Contract Settings',
  'menu.contractTypes': 'Contract Types',
  'menu.navigation.contractHandling': 'Contract Handling',
  'menu.navigation.contractAll': 'All Contracts',
  'menu.navigation.contractMine': 'My Contracts',
  'menu.navigation.contractTodo': 'Contract Tasks',
  'menu.contractTemplates': 'Contract Templates',
  'menu.contractBillingRules': 'Billing Rules',
  'menu.navigation.module.home': 'Home',
  'menu.navigation.module.assets': 'Spaces',
  'menu.navigation.module.asset': 'Assets',
  'menu.navigation.module.attraction': 'Investment',
  'menu.navigation.module.enterprises': 'Enterprises',
  'menu.navigation.module.reports': 'Reports',
  'menu.navigation.module.contracts': 'Contracts',
  'menu.navigation.module.property': 'Property',
  'menu.navigation.module.innovation': 'Enterprise Services',
  'menu.navigation.module.operations': 'Operations',
  'menu.navigation.module.hr': 'HR',
  'menu.navigation.module.finance': 'Finance',
  'menu.navigation.module.evaluation': 'Evaluation',
  'menu.navigation.module.settings': 'Settings',
  'menu.attraction.leads': 'Leads',
  'menu.attraction.customers': 'Customers',
  'menu.leadAll': 'All',
  'menu.leadMine': '我的线索',
  'menu.leadPool': '待领线索',
  'menu.customerAll': 'All',
  'menu.customerMine': '我的客户',
  'menu.customerPool': '待领客户',
  'menu.attraction.leadAll': '全部',
  'menu.attraction.leadMine': '我的线索',
  'menu.attraction.leadPool': '待领线索',
  'menu.attraction.customerAll': '全部',
  'menu.attraction.customerMine': '我的客户',
  'menu.attraction.customerPool': '待领客户',
  'menu.attraction.contacts': 'Contacts',
  'menu.attraction.opportunities': 'Opportunities',
  'menu.workbench': 'Workbench',
  'menu.home': 'Home',
  'menu.assets': 'Assets & Spaces',
  'menu.business': 'Business Management',
  'menu.contracts': 'Contract Ledger',
  'menu.innovation': 'Innovation Services',
  'menu.hr': 'Human Resources',
  'menu.finance': 'Finance Management',
  'menu.finance.overview': 'Finance Overview',
  'menu.finance.receivables': 'Receivables',
  'menu.finance.receipts': 'Receipts',
  'menu.finance.collectionLedger': 'Collection Ledger',
  'menu.finance.expenses': 'Expenses',
  'menu.finance.invoices': 'Invoices',
  'menu.reports': 'Data Reports',
  'menu.reports.overview': 'Reports Overview',
  'menu.reports.investment': 'Investment Reports',
  'menu.reports.finance': 'Financial Reports',
  'menu.reports.property': 'Property Reports',
  'menu.reports.settings': 'Report Settings',
  'menu.more-blocks': 'More Blocks',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.system': 'System',
  'menu.system.menu': 'Menu',
  'menu.system.user': 'User',
  'menu.system.role': 'Role',
  'menu.settings': 'System Settings',
  'menu.settings.permissions': 'Permission Management',
  'menu.settings.spaceConfig': 'Space Configuration',
  'menu.settings.approvalConfig': 'Approval Configuration',
  'menu.login': 'Login',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.park.spaceManagement': 'Space Management',
  'menu.park.spaceManagement.spacesOverview': 'Space Overview',
  'menu.park.spaceManagement.spaces': 'Space Directory',
  'menu.park.spaceManagement.otherAssets': 'Other Assets',
  'menu.asset': 'Assets',
  'menu.asset.detail': 'Asset Detail',
  'menu.asset.ledger': 'Asset Ledger',
  'menu.asset.suppliers': 'Suppliers',
  'menu.asset.reminders': 'Expiry Reminders',
  'menu.park.spaceManagement.spaceIncubation': 'Incubation Records',
  'menu.park.spaceManagement.spaceDetail': 'Space Details',
  'menu.park.spaceManagement.spaceUsage': 'Space Usage',
  'menu.park.property': 'Property Management',
  'menu.property': 'Property',
  'menu.property.propertyDashboard': 'Property Dashboard',
  'menu.property.workOrders': 'Property Work Orders',
  'menu.property.propertySlaRules': 'Work Order SLA Rules',
  'menu.property.accessControl': 'Access Control',
  'menu.property.parking': 'Parking Management',
  'menu.property.meetingRoom': 'Meeting Room Management',
  'menu.property.energyMeters': 'Meters',
  'menu.property.energy': 'Energy Management',
  'menu.property.energySpaces': 'Space Ledger',
  'menu.property.energyLedger': 'Meter Readings',
  'menu.property.energyAccounts': 'Enterprise Accounts',
  'menu.property.energyRates': 'Billing Rates',
  'menu.property.iotDevices': 'Connected Devices',
  'menu.enterprises.attraction': 'Investment & Admission',
  'menu.attraction': 'Investment Management',
  'menu.attraction.investmentProjects': 'Investment Projects',
  'menu.attraction.admissionApplications': 'Admission Applications',
  'menu.attraction.list': 'Enterprise Directory',
  'menu.enterprises.incubation': 'Incubation',
  'menu.enterprises.archives': 'Enterprise Archives',
  'menu.todos.group': 'Todo Center',
  'menu.todos.todoApproval': 'My Approvals',
  'menu.todos.todoBusiness': 'Business Todos',
  'menu.todos': 'Task Center',
  'menu.services.handling': 'Service Handling',
  'menu.services.marketplace': 'Service Marketplace',
  'menu.resources.technology': 'Technology Resources',
  'menu.operations.activityOps': 'Activity Operations',
  'menu.portal.site': 'Portal Content',
  'menu.portal.publish': 'Publishing',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.workbench': 'Back to Workbench',
  'menu.account.tenantManagement': 'Tenant Management',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
  'menu.park': 'Park',
  'menu.enterprises': 'Enterprises',
  'menu.services': 'Services',
  'menu.operations.partyBuilding': 'Party Building',
  'menu.operations': 'Operations Management',
  'menu.evaluation': 'Evaluation',
  'menu.overview': 'Overview',
  'menu.evaluation.overview': 'Overview',
  'menu.growth.archives': 'Growth Records',
  'menu.portal.site.banners': 'Banners',
  'menu.navigation.admission': 'Admission & Exit',
  'menu.navigation.incubationGrowth': 'Incubation & Growth',
  'menu.navigation.resourceMatching': 'Resource Matching',
  'menu.navigation.detail': 'Details',
  'menu.navigation.create': 'Create',
  'menu.navigation.edit': 'Edit',
  'menu.navigation.claimReview': 'Claim Review',
  'menu.navigation.reads': 'Read Receipts',
  'menu.portal': 'Portal Management',
  'menu.park.leases': 'Leasing',
};
